/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Button, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

import cancelIcon from '../../../../assets/images/Icon-cancel.png';
import ContractsUsingContactModal from './ContractsUsingContactModal';
import CopyContactComponent from './CopyContactComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  getContactDetails,
  getExistingContactDetails,
  getSingleContractUsingContact,
  getAllManufacturer,
  getGetAllProviderList,
} from '../store/ManufacturerAction';
import { PaperComponent } from '../../../../SharedModules/utilities/utilities';
import { EMAIL_ID_REGEX } from '../../../../SharedModules/AppConstants';

export default function ManufacturerContact(props) {
  const {
    showNameErr,
    showAddrErr,
    showCityErr,
    showStateErr,
    showZipErr,
    showZip4Err,
    showPhoneErr,
    showEmailErr,
    callContactDetailApi,
    setCallContactDetailApi,
    contactDetail,
    setSuccessMessage,
    setErrorMessages,
    setContactDetail,
    addEditReduxDataManufacturerTab,
    addEditManufacturerTabData,
    setDisabledSaveCancelBtn,
    disabledSaveCancelBtn,
    resetContactBaseline,
    errorMessages,
    selectMFGData,
    isEnablebyRole,
  } = props;
  const dispatch = useDispatch();
  const getExistingContactDetailsValue = (value) =>
    dispatch(getExistingContactDetails(value));
  const getContactDetailsValue = (value) => dispatch(getContactDetails(value));
  const getContractUsingSingleContact = (value) =>
    dispatch(getSingleContractUsingContact(value));
  const existingContactDetails = useSelector((state) => {
    if (props.CreateManufacturer) return [];
    // eslint-disable-next-line no-else-return
    else return state.sharedState.ManufacturerReducer.existingContactDetails;
  });
  const singleManufacturerDetail = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.manufacturerDetailsList;
  });
  const contactTypeDropDown = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.allContactTypeDropDown;
  });
  const contactDetails = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.contactDetails;
  });
  const FetchAllProviderListData = useSelector(
    (state) => state.sharedState.ManufacturerReducer.allProviderListData
  );
  const contractUsingContactList = useSelector((state) => {
    return state.sharedState.ManufacturerReducer?.contractUsingContactData;
  });
  const [keyType, setKeyType] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [contractUsingContactModal, setContractUsingContactModal] =
    React.useState(false);
  const [selectedContact, setSelectedContact] = React.useState(null);
  // set error message function
  const errorMessagesArray = [...errorMessages];
  const initializeContact = {
    contactSeqNum: null,
    key: null,
    keyTypeCd: 'MFG',
    contactTypeCd: contactDetail.contactTypeCd,
    contactName: '',
    corpName: '',
    addrLine1: '',
    addrLine2: '',
    addrLine3: '',
    city: '',
    stateCd: '',
    zip: '',
    zip4: '',
    phoneNum: '',
    phoneExtension: '',
    faxNum: '',
    email: '',
  };
  const [contactData, setContactData] = React.useState(initializeContact);
  const [resetContact, setResetContact] = React.useState(initializeContact);
  const [windowWidth, setWindowWidth] = React.useState(window.screen.width);
  // Baseline of last clean Contact form values. Save stays disabled when current
  // values match this snapshot (including after user reverts a field).
  const originalContactRef = React.useRef(null);
  const userEditedContactRef = React.useRef(false);
  const CONTACT_COMPARE_FIELDS = [
    'contactName',
    'corpName',
    'addrLine1',
    'addrLine2',
    'addrLine3',
    'city',
    'stateCd',
    'zip',
    'zip4',
    'phoneNum',
    'phoneExtension',
    'faxNum',
    'email',
  ];
  const normalizeContactField = (value) => {
    if (value === null || value === undefined) return '';
    return typeof value === 'string' ? value.trim() : String(value);
  };
  const getComparableContact = (contact = {}) => {
    return CONTACT_COMPARE_FIELDS.reduce((acc, field) => {
      acc[field] = normalizeContactField(contact[field]);
      return acc;
    }, {});
  };
  const setOriginalContactBaseline = (contact) => {
    originalContactRef.current = getComparableContact(contact);
  };
  const isContactFormUnchanged = (contact) => {
    if (!originalContactRef.current) return false;
    const current = getComparableContact(contact);
    const original = originalContactRef.current;
    return CONTACT_COMPARE_FIELDS.every(
      (field) => current[field] === original[field]
    );
  };
  const syncSaveButtonWithContact = (updatedContact) => {
    const unchanged = isContactFormUnchanged(updatedContact);
    setDisabledSaveCancelBtn(unchanged);
    return unchanged;
  };
  // Keep baseline in sync while the manufacturer form is clean (load/save/cancel).
  // Also capture an initial snapshot for create/add flows where Save starts enabled.
  React.useEffect(() => {
    if (disabledSaveCancelBtn) {
      setOriginalContactBaseline(contactDetail);
      userEditedContactRef.current = false;
    } else if (!originalContactRef.current) {
      setOriginalContactBaseline(contactDetail);
    }
  }, [disabledSaveCancelBtn, contactDetail]);
  // call after onchange event
  const handleOnChangeEvent = async (e, name) => {
    // Contact Type is browse-only — do not treat it as a form edit for Save.
    if (name !== 'contactTypeCd') {
      userEditedContactRef.current = true;
    }
    setSuccessMessage([]);
    if (contactDetail.contactTypeCd === 'MFGINV' && !props.CreateManufacturer) {
      getContactDetailsValue(null);
    }
    if (name === 'contactTypeCd') {
      const resultList = await getContactDetailsValue({
        keyTypeCd: 'MFG',
        key: selectMFGData.mfgId,
        contactTypeCd: e.target.value,
      });
      if (resultList.contactDetails) {
        let updatedContact;
        if (
          resultList.contactDetails &&
          resultList.contactDetails.length === 0
        ) {
          getContractUsingSingleContact(null);
          updatedContact = {
            contactSeqNum:
              existingContactDetails?.filter((x) => {
                return x.contactTypeCd === e.target.value;
              }).length > 0
                ? contactDetail.contactSeqNum
                : null,
            key: null,
            keyTypeCd: 'MFG',
            contactTypeCd: e.target.value,
            contactName: '',
            corpName: '',
            addrLine1: '',
            addrLine2: '',
            addrLine3: '',
            city: '',
            stateCd: '',
            zip: '',
            zip4: '',
            phoneNum: '',
            phoneExtension: '',
            faxNum: '',
            email: '',
            corrLinkId: null,
          };
        } else {
          const tempObj = resultList.contactDetails[0] || {};
          getContractUsingSingleContact({
            contactSeqNum: tempObj.contactSeqNum,
          });
          const zip4 = tempObj.zip4 ? String(tempObj.zip4).trim() : '';
          const email = tempObj.email ? String(tempObj.email).trim() : '';
          const phoneNum = tempObj.phoneNum
            ? String(tempObj.phoneNum).trim()
            : '';
          updatedContact = {
            ...contactDetail,
            key: keyType,
            contactTypeCd: e.target.value,
            contactSeqNum:
              existingContactDetails?.filter((x) => {
                return x.contactTypeCd === e.target.value;
              }).length > 0
                ? tempObj.contactSeqNum
                : null,
            contactName: tempObj.contactName || '',
            corpName: tempObj.corpName || '',
            addrLine1: tempObj.addrLine1 || '',
            addrLine2: tempObj.addrLine2 || '',
            addrLine3: tempObj.addrLine3 || '',
            city: tempObj.city || '',
            stateCd: tempObj.stateCd || '',
            zip: tempObj.zip || '',
            zip4,
            phoneNum,
            phoneExtension: tempObj.phoneExtension || '',
            faxNum: tempObj.faxNum || '',
            email,
            corrLinkId: tempObj.corrLinkId ?? null,
          };
          // Clear Redux so the contactDetails effect does not re-apply stale data.
          getContactDetailsValue(null);
        }
        setOriginalContactBaseline(updatedContact);
        if (typeof resetContactBaseline === 'function') {
          resetContactBaseline(updatedContact);
        }
        setContactDetail(updatedContact);
        addEditReduxDataManufacturerTab({
          ...addEditManufacturerTabData,
          contactDetail: updatedContact,
        });
        setSelectedContact(null);
      }
    } else if (
      name === 'phoneNum' ||
      name === 'zip' ||
      name === 'zip4' ||
      name === 'faxNum' ||
      name === 'phoneExtension'
    ) {
      const onlyNumbs = e.target.value.replace(/[^0-9]/g, '');
      const updatedContact = {
        ...contactDetail,
        [name]: onlyNumbs.trim(),
      };
      const unchanged = syncSaveButtonWithContact(updatedContact);
      setContactDetail(updatedContact);
      addEditReduxDataManufacturerTab({
        ...addEditManufacturerTabData,
        disabledSaveCancelBtn: unchanged,
        contactDetail: updatedContact,
      });
    } else {
      const updatedContact = {
        ...contactDetail,
        [name]: e.target.value,
      };
      const unchanged = syncSaveButtonWithContact(updatedContact);
      addEditReduxDataManufacturerTab({
        ...addEditManufacturerTabData,
        disabledSaveCancelBtn: unchanged,
        contactDetail: updatedContact,
      });
      setContactDetail(updatedContact);
    }
  };

  const initializeContactReset = {
    contactSeqNum: null,
    key: null,
    keyTypeCd: 'MFG',
    contactTypeCd: contactDetail.contactTypeCd,
    contactName: contactDetail.contactName,
    corpName: contactDetail.corpName,
    addrLine1: contactDetail.addrLine1,
    addrLine2: contactDetail.addrLine2,
    addrLine3: contactDetail.addrLine3,
    city: contactDetail.city,
    stateCd: contactDetail.stateCd,
    zip: contactDetail.zip,
    zip4: contactDetail.zip4,
    phoneNum: contactDetail.phoneNum,
    phoneExtension: contactDetail.phoneExtension,
    faxNum: contactDetail.faxNum,
    email: contactDetail.email,
  };
  React.useEffect(() => {
    if (
      !props.CreateManufacturer &&
      existingContactDetails &&
      existingContactDetails?.length === 0
    ) {
      getExistingContactDetailsValue({
        key: props.CreateManufacturer ? null : [selectMFGData.mfgId],
        keyTypeCd: 'MFG',
      });
    }
    if (
      !FetchAllProviderListData?.length > 0 &&
      !selectMFGData?.callAllProviderAPI
    ) {
      dispatch(getGetAllProviderList(''));
    }
  }, []);
  // set default values
  React.useEffect(() => {
    if (!props.CreateManufacturer) {
      const MFGDetail =
        singleManufacturerDetail && singleManufacturerDetail.mfgVO;
      if (MFGDetail && Object.keys(MFGDetail).length > 0) {
        setKeyType({ keyType: MFGDetail && MFGDetail.mfgId });
      }
    }
  }, [singleManufacturerDetail]);
  // change Contact Type after call
  React.useEffect(() => {
    if (contactDetails && contactDetails.length > 0) {
      const tempObj = contactDetails[0];
      getContractUsingSingleContact({
        contactSeqNum: tempObj.contactSeqNum,
      });
      tempObj.zip4 = tempObj.zip4 ? tempObj.zip4.trim() : '';
      tempObj.email = tempObj.email ? tempObj.email.trim() : '';
      tempObj.phoneNum = tempObj.phoneNum ? tempObj.phoneNum.trim() : '';
      const updatedContact = {
        ...contactDetail,
        key: keyType,
        contactTypeCd: tempObj.contactTypeCd || contactDetail.contactTypeCd,
        contactSeqNum:
          existingContactDetails?.filter((x) => {
            return x.contactTypeCd === tempObj.contactTypeCd;
          }).length > 0
            ? tempObj.contactSeqNum
            : null,
        contactName: tempObj.contactName || '',
        corpName: tempObj.corpName || '',
        addrLine1: tempObj.addrLine1 || '',
        addrLine2: tempObj.addrLine2 || '',
        addrLine3: tempObj.addrLine3 || '',
        city: tempObj.city || '',
        stateCd: tempObj.stateCd || '',
        zip: tempObj.zip || '',
        zip4: tempObj.zip4 || '',
        phoneNum: tempObj.phoneNum || '',
        phoneExtension: tempObj.phoneExtension || '',
        faxNum: tempObj.faxNum || '',
        email: tempObj.email || '',
        corrLinkId: tempObj.corrLinkId ?? null,
      };
      setContactDetail(updatedContact);
      if (userEditedContactRef.current) {
        const unchanged = syncSaveButtonWithContact(updatedContact);
        addEditReduxDataManufacturerTab({
          ...addEditManufacturerTabData,
          disabledSaveCancelBtn: unchanged,
          contactDetail: updatedContact,
        });
      } else {
        setOriginalContactBaseline(updatedContact);
      }
      getContactDetailsValue(null);
    } else {
      // eslint-disable-next-line no-unused-expressions
      errorMessagesArray &&
        errorMessagesArray.length > 0 &&
        errorMessagesArray.forEach((x, key) => {
          if (x === constantMessageData.MFG_NO_CONTRACT_USING_CONTACT_ERROR) {
            return (
              errorMessagesArray.splice(key, 1),
              setErrorMessages([...new Set(errorMessagesArray)]),
              addEditReduxDataManufacturerTab({
                ...addEditManufacturerTabData,
                errorMessages: [...new Set(errorMessagesArray)],
              })
            );
          }
        });
      initializeContactReset.contactTypeCd = contactDetail.contactTypeCd;
      setResetContact(initializeContactReset);
    }
  }, [contactDetails]);
  const setContactIfNotEmpty = () => {
    userEditedContactRef.current = true;
    setSuccessMessage([]);
    if (selectedContact) {
      setContactData(selectedContact);
      const newObj = selectedContact;
      const updatedContact = {
        ...contactDetail,
        key: keyType,
        contactSeqNum: contactDetail.contactSeqNum,
        contactName: newObj.contactName || '',
        corpName: newObj.corpName || '',
        addrLine1: newObj.addrLine1 || '',
        addrLine2: newObj.addrLine2 || '',
        addrLine3: newObj.addrLine3 || '',
        city: newObj.city || '',
        stateCd: newObj.stateCd || '',
        zip: newObj.zip || '',
        zip4: newObj.zip4 || '',
        phoneNum: newObj.phoneNum || '',
        phoneExtension: newObj.phoneExtension || '',
        faxNum: newObj.faxNum || '',
        email: newObj.email || '',
      };
      const unchanged = syncSaveButtonWithContact(updatedContact);
      setContactDetail(updatedContact);
      addEditReduxDataManufacturerTab({
        ...addEditManufacturerTabData,
        disabledSaveCancelBtn: unchanged,
        contactDetail: updatedContact,
      });
      setSelectedContact(null);
    }
    handleClose();
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    dispatch(getAllManufacturer('copyContact'));
  };

  React.useEffect(() => {
    if (contactTypeDropDown && contactTypeDropDown.length > 0) {
      if (!props.CreateManufacturer && callContactDetailApi) {
        getContactDetailsValue({
          keyTypeCd: 'MFG',
          key: selectMFGData.mfgId,
          contactTypeCd: contactDetail.contactTypeCd,
        });
        setCallContactDetailApi(false);
        addEditReduxDataManufacturerTab({
          ...addEditManufacturerTabData,
          callContactDetailApi: false,
        });
      } else if (
        contactDetail.contactTypeCd === 'MFGINV' &&
        !props.CreateManufacturer
      ) {
        getContactDetailsValue(null);
      }
    }
  }, [contactTypeDropDown, callContactDetailApi]);

  // Set lable text according to the screen width for Phone number
  const textReplace = () => {
    setWindowWidth(window.screen.width);
  };

  React.useEffect(() => {
    window.addEventListener('resize', textReplace);
  }, [windowWidth]);

  const handleCloseContractPopup = () => {
    setContractUsingContactModal(false);
  };
  const handleShowContractUsingContactPopup = () => {
    if (contractUsingContactList && contractUsingContactList.length > 0) {
      setContractUsingContactModal(true);
      // eslint-disable-next-line no-unused-expressions
      errorMessagesArray &&
        errorMessagesArray.length > 0 &&
        errorMessagesArray.forEach((x, key) => {
          if (x === constantMessageData.MFG_NO_CONTRACT_USING_CONTACT_ERROR) {
            return (
              errorMessagesArray.splice(key, 1),
              setErrorMessages([...new Set(errorMessagesArray)]),
              addEditReduxDataManufacturerTab({
                ...addEditManufacturerTabData,
                errorMessages: [...new Set(errorMessagesArray)],
              })
            );
          }
        });
    } else {
      setDisabledSaveCancelBtn(false);
      setSuccessMessage([]);
      errorMessagesArray.push(
        constantMessageData.MFG_NO_CONTRACT_USING_CONTACT_ERROR
      );
      setErrorMessages([...new Set(errorMessagesArray)]);
      addEditReduxDataManufacturerTab({
        ...addEditManufacturerTabData,
        disabledSaveCancelBtn: false,
        errorMessages: [...new Set(errorMessagesArray)],
      });
    }
  };
  return (
    <div data-testid="ManufacturerContact">
      <Dialog
        data-testid="contract-using-contact-popup"
        className="inbuilt-dialog dialogPanel custom-check dialog-600"
        open={contractUsingContactModal}
        maxWidth="md"
        id="contract-using-contact-popup"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className="copy-contact-title"
          style={{ cursor: 'move' }}
          id="draggable-dialog-title"
        >
          <div className="float-left dialog-heading-txt">
            Contracts using this Contact
          </div>

          <div
            className="close-popup-icon float-right"
            role="button"
            onClick={handleCloseContractPopup}
          >
            <img alt="" src={cancelIcon} />
          </div>
          <div className="clearfix" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {contractUsingContactList &&
              contractUsingContactList?.length > 0 && (
                <ContractsUsingContactModal data={contractUsingContactList} />
              )}
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={open}
        data-testid="close-copy-contact-popup"
        maxWidth="md"
        className="inbuilt-dialog dialogPanel custom-check dialog-600"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className="copy-contact-title"
          style={{ cursor: 'move' }}
          id="draggable-dialog-title"
        >
          <div className="float-left dialog-heading-txt mt-1">
            Copy Contact from...
          </div>

          <div
            className="close-popup-icon float-right"
            role="button"
            onClick={handleClose}
          >
            <img alt="" src={cancelIcon} />
          </div>
          <div className="clearfix" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <CopyContactComponent
              Manufacturer
              setSelectedContact={setSelectedContact}
              mfgId={selectMFGData.mfgId}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className="btn-wrapper mb-2">
            <div className="float-right hide-on-print">
              <Button
                className="btn btn-success btn-search"
                data-testid="reset-contact-detail"
                onClick={setContactIfNotEmpty}
              >
                <SVGComponent iconName="Icon_awesome-check-circle" />
                Ok
              </Button>
              <Button
                data-testid="copy-contact-close"
                className="btn btn-cancel btn-primary"
                onClick={handleClose}
              >
                <SVGComponent iconName="Icon-cancel" />
                Cancel
              </Button>
            </div>
            <div className="clearfix" />
          </div>
        </DialogActions>
      </Dialog>

      <div>
        <div className="">
          <div className="panel-header action-block">
            <div className="float-right th-icon-group mt-1 hide-on-print">
              <Dropdown
                data-testid="actionDropdown"
                key="actionDropdown"
                className="icon-dropdown-container"
              >
                <Dropdown.Toggle className="icon-dropdown" aria-label="export">
                  <SVGComponent iconName="Export-icon" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {props.CreateManufacturer ? (
                    <Dropdown.Item disabled>
                      Show Contracts using this Contact
                    </Dropdown.Item>
                  ) : (
                    <Dropdown.Item
                      key="actionDropdown1"
                      data-testid="actionDropdown1"
                      role="button"
                      onClick={handleShowContractUsingContactPopup}
                    >
                      Show Contracts using this Contact
                    </Dropdown.Item>
                  )}
                  {contactDetail.contactTypeCd &&
                  contactDetail.contactTypeCd.substring(0, 3) === 'CMS' ? (
                    <Dropdown.Item disabled>Copy Contact from...</Dropdown.Item>
                  ) : (
                    <Dropdown.Item
                      key="actionDropdown2"
                      data-testid="actionDropdown2"
                      role="button"
                      onClick={handleOpen}
                      disabled={!isEnablebyRole}
                    >
                      Copy Contact from...
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <div className="tab-body">
            <form autoComplete="off">
              <div className="tab-holder">
                <fieldset className="custom-fieldset custom-height">
                  <legend>Contact Information</legend>
                  <div className="form-wrapper">
                    <div className="mui-custom-form with-select">
                      <TextField
                        id="contact_type"
                        data-testid="contact_type"
                        label="Contact Type"
                        fullWidth
                        select
                        placeholder=""
                        inputProps={{ maxLength: 10, id: 'contact_type' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={!isEnablebyRole}
                        value={contactDetail.contactTypeCd}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'contactTypeCd');
                        }}
                      >
                        {contactTypeDropDown?.length > 0
                          ? contactTypeDropDown
                              ?.filter((x) => {
                                return x.contactTypeCd;
                              })
                              ?.map((item) => {
                                return (
                                  <MenuItem
                                    key={item.contactTypeCd}
                                    value={item.contactTypeCd}
                                  >
                                    {`${item.contactTypeCd} | ${item.shortDescr}`}
                                  </MenuItem>
                                );
                              })
                          : null}
                      </TextField>
                    </div>
                    <div className="mui-custom-form input-md">
                      <fieldset className="custom-fieldset custom-fieldset-43">
                        <legend className="legend-font">
                          Existing Contacts
                        </legend>
                        <div className="form-wrapper">
                          {existingContactDetails?.length > 0
                            ? existingContactDetails
                                .filter((x) => {
                                  return (
                                    x.contactTypeCd !== '' &&
                                    x.contactTypeCd !== null
                                  );
                                })
                                .map((item, index) => {
                                  return (
                                    <h6>
                                      {item.contactTypeCd}{' '}
                                      {existingContactDetails.filter((x) => {
                                        return (
                                          x.contactTypeCd !== '' &&
                                          x.contactTypeCd !== null
                                        );
                                      }).length ===
                                      index + 1
                                        ? null
                                        : ', '}
                                    </h6>
                                  );
                                })
                            : null}
                        </div>
                      </fieldset>
                    </div>
                    <div className="line-break-div" />
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="Name"
                        label="Name"
                        data-testid="name"
                        className="mandate-fields"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 50, id: 'Name' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required
                        value={
                          contactDetail.contactName !== null
                            ? contactDetail.contactName
                            : ''
                        }
                        disabled={
                          !!(
                            contactDetail.contactTypeCd &&
                            contactDetail.contactTypeCd.substring(0, 3) ===
                              'CMS'
                          )
                        }
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'contactName');
                        }}
                        helperText={
                          !contactDetail.contactName && showNameErr
                            ? constantMessageData.NAME_REQUIRED
                            : null
                        }
                        error={
                          !contactDetail.contactName && showNameErr
                            ? constantMessageData.NAME_REQUIRED
                            : null
                        }
                      />
                    </div>
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="Corporation_Name"
                        label="Corporation Name"
                        data-testid="Corporation-name"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 50, id: 'Corporation_Name' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDetail.corpName !== null
                            ? contactDetail.corpName
                            : ''
                        }
                        disabled={
                          !!(
                            contactDetail.contactTypeCd &&
                            contactDetail.contactTypeCd.substring(0, 3) ===
                              'CMS'
                          )
                        }
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'corpName');
                        }}
                      />
                    </div>
                    <div className="line-break-div" />
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="Address Lines"
                        data-testid="Address-line"
                        label="Address Lines 1"
                        className="mandate-fields"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 50 }}
                        InputLabelProps={{ shrink: true }}
                        required
                        value={
                          contactDetail.addrLine1 !== null
                            ? contactDetail.addrLine1
                            : ''
                        }
                        disabled={
                          !!(
                            contactDetail.contactTypeCd &&
                            contactDetail.contactTypeCd.substring(0, 3) ===
                              'CMS'
                          )
                        }
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'addrLine1');
                        }}
                        helperText={
                          (contactDetail.addrLine1 === '' ||
                            contactDetail.addrLine1 === null) &&
                          showAddrErr
                            ? constantMessageData.ADDRESS_LINE1_REQUIRED
                            : null
                        }
                        error={
                          (contactDetail.addrLine1 === '' ||
                            contactDetail.addrLine1 === null) &&
                          showAddrErr
                            ? constantMessageData.ADDRESS_LINE1_REQUIRED
                            : null
                        }
                      />
                    </div>
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="address_lines_2"
                        label="Address Lines 2"
                        data-testid="address-line2"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 50, id: 'address_lines_2' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDetail.addrLine2 !== null
                            ? contactDetail.addrLine2
                            : ''
                        }
                        disabled={
                          !!(
                            contactDetail.contactTypeCd &&
                            contactDetail.contactTypeCd.substring(0, 3) ===
                              'CMS'
                          )
                        }
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'addrLine2');
                        }}
                      />
                    </div>
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="address_lines_3"
                        label="Address Lines 3"
                        data-testid="address-lines3"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 50, id: 'address_lines_2' }}
                        InputLabelProps={{ shrink: true }}
                        value={
                          contactDetail.addrLine3 !== null
                            ? contactDetail.addrLine3
                            : ''
                        }
                        disabled={
                          !!(
                            contactDetail.contactTypeCd &&
                            contactDetail.contactTypeCd.substring(0, 3) ===
                              'CMS'
                          )
                        }
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'addrLine3');
                        }}
                      />
                    </div>
                    <div className="line-break-div" />
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="city"
                        data-testid="city"
                        label="City"
                        className="mandate-fields"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 30, id: 'city' }}
                        InputLabelProps={{ shrink: true }}
                        required
                        value={
                          contactDetail.city !== null ? contactDetail.city : ''
                        }
                        disabled={
                          !!(
                            contactDetail.contactTypeCd &&
                            contactDetail.contactTypeCd.substring(0, 3) ===
                              'CMS'
                          )
                        }
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'city');
                        }}
                        helperText={
                          (contactDetail.city === '' ||
                            contactDetail.city === null) &&
                          showCityErr
                            ? constantMessageData.CITY_REQUIRED
                            : null
                        }
                        error={
                          (contactDetail.city === '' ||
                            contactDetail.city === null) &&
                          showCityErr
                            ? constantMessageData.CITY_REQUIRED
                            : null
                        }
                      />
                    </div>
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="state"
                        label="State"
                        data-testid="state"
                        className="mandate-fields"
                        fullWidth
                        placeholder=""
                        required
                        inputProps={{ maxLength: 2, id: 'state' }}
                        InputLabelProps={{ shrink: true }}
                        value={
                          contactDetail.stateCd !== null
                            ? contactDetail.stateCd
                            : ''
                        }
                        disabled={
                          !!(
                            contactDetail.contactTypeCd &&
                            contactDetail.contactTypeCd.substring(0, 3) ===
                              'CMS'
                          )
                        }
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'stateCd');
                        }}
                        helperText={
                          (contactDetail.stateCd === '' ||
                            contactDetail.stateCd === null) &&
                          showStateErr
                            ? constantMessageData.STATE_REQUIRED
                            : null
                        }
                        error={
                          (contactDetail.stateCd === '' ||
                            contactDetail.stateCd === null) &&
                          showStateErr
                            ? constantMessageData.STATE_REQUIRED
                            : null
                        }
                      />
                    </div>
                    <div className="mui-custom-form input-md">
                      <div className="row">
                        <div className="col-sm-6 col-md-7 pr-sm-0 pr-md-2">
                          <TextField
                            id="Zip"
                            label="Zip"
                            data-testid="zip"
                            className="mandate-fields"
                            fullWidth
                            required
                            placeholder=""
                            inputProps={{ maxLength: 10 }}
                            InputLabelProps={{ shrink: true }}
                            value={
                              contactDetail.zip !== null
                                ? contactDetail.zip
                                : ''
                            }
                            disabled={
                              !!(
                                contactDetail.contactTypeCd &&
                                contactDetail.contactTypeCd.substring(0, 3) ===
                                  'CMS'
                              )
                            }
                            onChange={(e) => {
                              handleOnChangeEvent(e, 'zip');
                            }}
                            helperText={
                              (contactDetail.zip === '' ||
                                contactDetail.zip === null) &&
                              showZipErr
                                ? constantMessageData.ZIP_REQUIRED
                                : null
                            }
                            error={
                              (contactDetail.zip === '' ||
                                contactDetail.zip === null) &&
                              showZipErr
                                ? constantMessageData.ZIP_REQUIRED
                                : null
                            }
                          />
                        </div>
                        <div className="col-sm-6 col-md-5 mt-md-0 pl-md-0">
                          <TextField
                            id="Zip+4"
                            label="Zip+4"
                            data-testid="zip4"
                            fullWidth
                            placeholder=""
                            inputProps={{ maxLength: 4 }}
                            InputLabelProps={{ shrink: true }}
                            value={
                              contactDetail.zip4 !== null &&
                              contactDetail.zip4 !== ''
                                ? contactDetail.zip4
                                : ''
                            }
                            disabled={
                              !!(
                                contactDetail.contactTypeCd &&
                                contactDetail.contactTypeCd.substring(0, 3) ===
                                  'CMS'
                              )
                            }
                            onChange={(e) => {
                              handleOnChangeEvent(e, 'zip4');
                            }}
                            onBlur={(e) => {
                              props.handleOnBlurEvent(e, 'zip4');
                            }}
                            helperText={
                              showZip4Err ||
                              (props.errorMessages &&
                                props.errorMessages.length > 0 &&
                                props.errorMessages.filter((x) => {
                                  return x.includes('Invalid Zip4');
                                }).length > 0)
                                ? constantMessageData.ZIP4_REQUIRED
                                : null
                            }
                            error={
                              showZip4Err ||
                              (props.errorMessages &&
                                props.errorMessages.length > 0 &&
                                props.errorMessages.filter((x) => {
                                  return x.includes('Invalid Zip4');
                                }).length > 0)
                                ? constantMessageData.ZIP4_REQUIRED
                                : null
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="line-break-div" />
                    <div className="mui-custom-form input-md">
                      <div className="row">
                        <div className="col-sm-6 col-md-7 pr-sm-0 pr-md-2">
                          <TextField
                            id="Phone Number"
                            label={
                              windowWidth >= 745 ? 'Phone Number' : 'Phone No.'
                            }
                            data-testid="phone"
                            className="mandate-fields"
                            fullWidth
                            required
                            placeholder=""
                            inputProps={{ maxLength: 10 }}
                            InputLabelProps={{ shrink: true }}
                            value={
                              contactDetail &&
                              contactDetail.phoneNum !== undefined &&
                              contactDetail.phoneNum !== null
                                ? contactDetail.phoneNum.toString().trim()
                                : ''
                            }
                            disabled={
                              !!(
                                contactDetail.contactTypeCd &&
                                contactDetail.contactTypeCd.substring(0, 3) ===
                                  'CMS'
                              )
                            }
                            onChange={(e) => {
                              handleOnChangeEvent(e, 'phoneNum');
                            }}
                            onBlur={(e) => {
                              props.handleOnBlurEvent(e, 'phoneNum');
                            }}
                            helperText={
                              showPhoneErr ||
                              (props.errorMessages &&
                                props.errorMessages.length > 0 &&
                                props.errorMessages.filter((x) => {
                                  return x.includes('Invalid Phone Number');
                                }).length > 0)
                                ? contactDetail.phoneNum === '' ||
                                  contactDetail.phoneNum === null
                                  ? constantMessageData.PHONE_REQUIRED
                                  : contactDetail.phoneNum !== null &&
                                    contactDetail.phoneNum.trim().length <= 9
                                  ? constantMessageData.PHONE_INVALID_ERROR
                                  : null
                                : null
                            }
                            error={
                              showPhoneErr ||
                              (props.errorMessages &&
                                props.errorMessages.length > 0 &&
                                props.errorMessages.filter((x) => {
                                  return x.includes('Invalid Phone Number');
                                }).length > 0)
                                ? contactDetail.phoneNum === '' ||
                                  contactDetail.phoneNum === null
                                  ? constantMessageData.PHONE_REQUIRED
                                  : contactDetail.phoneNum !== null &&
                                    contactDetail.phoneNum.trim().length <= 9
                                  ? constantMessageData.PHONE_INVALID_ERROR
                                  : null
                                : null
                            }
                          />
                        </div>
                        <div className="col-sm-6 col-md-5 mt-md-0 pl-md-0">
                          <TextField
                            id="Extension"
                            label="Extension"
                            data-testid="Extension"
                            fullWidth
                            placeholder=""
                            inputProps={{ maxLength: 6 }}
                            InputLabelProps={{ shrink: true }}
                            value={
                              contactDetail.phoneExtension !== null
                                ? contactDetail.phoneExtension
                                : ''
                            }
                            disabled={
                              !!(
                                contactDetail.contactTypeCd &&
                                contactDetail.contactTypeCd.substring(0, 3) ===
                                  'CMS'
                              )
                            }
                            onChange={(e) => {
                              handleOnChangeEvent(e, 'phoneExtension');
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="Fax Number"
                        label="Fax Number"
                        data-testid="fax"
                        fullWidth
                        disabled={!isEnablebyRole}
                        placeholder=""
                        inputProps={{ maxLength: 10 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDetail.faxNum !== null
                            ? contactDetail.faxNum
                            : ''
                        }
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'faxNum');
                        }}
                      />
                    </div>
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="Email Address"
                        label="Email Address"
                        data-testid="email"
                        className="mandate-fields"
                        fullWidth
                        required
                        type="text"
                        disabled={!isEnablebyRole}
                        placeholder=""
                        inputProps={{ maxLength: 50 }}
                        InputLabelProps={{ shrink: true }}
                        value={
                          contactDetail.email !== null
                            ? contactDetail.email
                            : ''
                        }
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'email');
                        }}
                        onBlur={(e) => {
                          props.handleOnBlurEvent(e, 'email');
                        }}
                        helperText={
                          showEmailErr ||
                          (props.errorMessages &&
                            props.errorMessages.length > 0 &&
                            props.errorMessages.filter((x) => {
                              return x.includes('Invalid Email');
                            }).length > 0)
                            ? contactDetail.email === '' ||
                              contactDetail.email === null
                              ? constantMessageData.EMAIL_REQUIRED
                              : contactDetail.email !== null &&
                                !EMAIL_ID_REGEX.test(contactDetail.email.trim())
                              ? constantMessageData.EMAIL_INVALID
                              : null
                            : null
                        }
                        error={
                          showEmailErr ||
                          (props.errorMessages &&
                            props.errorMessages.length > 0 &&
                            props.errorMessages.filter((x) => {
                              return x.includes('Invalid Email');
                            }).length > 0)
                            ? contactDetail.email === '' ||
                              contactDetail.email === null
                              ? constantMessageData.EMAIL_REQUIRED
                              : contactDetail.email !== null &&
                                !EMAIL_ID_REGEX.test(contactDetail.email.trim())
                              ? constantMessageData.EMAIL_INVALID
                              : null
                            : null
                        }
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
